<div class="layout-wrapper">
  <router-outlet></router-outlet>
  <sigv-loading-mask [isLoading]="isLoading"></sigv-loading-mask>
</div>
